import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
  customCheckbox: {
    '& .MuiIconButton-label': {
      color: '#3E8649',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '40px',
      borderRadius: '8px', 
    },
    '& .MuiCheckbox-root': {
      border: '1px', 
      borderRadius: '8px', 
    },
  },
  customLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: '17px', 
      color: '#525252',  
      fontWeight: 'bold',
    },
  },
}));
